import React, { Fragment } from 'react';
import { withRouter, Prompt } from 'react-router-dom';

import { useQuizContext } from 'Context/QuizContext';
import { QUIZ_VARIANTS } from 'Components/Quiz/constant';
import GradedExamModal, {
  GRADED_EXAM_MODAL_VARIANT,
  GRADED_EXAM_MODAL_VARIANT_PROPS,
} from 'Components/Quiz/Components/GradedExamModal';

import BlockNavigationDialogView from './BlockNavigationDialog.view';

const BlockNavigation = withRouter(({ history, when }) => {
  const { variant } = useQuizContext();
  const [nextLocation, setNextLocation] = React.useState(null);
  const [alert, setAlert] = React.useState(false);

  const handleBlockNavigation = () => {
    setAlert(false);
  };

  const handleAllowNavigation = () => {
    history.push(nextLocation);
    setAlert(false);
  };

  const gradedExamVariantProps =
    GRADED_EXAM_MODAL_VARIANT_PROPS[GRADED_EXAM_MODAL_VARIANT.EXAM_ESCAPE] ?? {};

  return (
    <Fragment>
      <Prompt
        when={when && !alert}
        message={(location) => {
          /**
           * message prop of <Prompt /> component can accept both string and function.
           * If string is passed to <Prompt />, it will show browser confirm dialog for users to confirm/cancel navigation.
           * In this case we want to use custom alertComponent instead, therefore, we need to return "false" to cancel navigation.
           * and at the same time set "alert = true" to open the alertComponent which will be passed to this component as a prop.
           * The nextLocation needs to be keep in state so the component can correctly navigate if the users confirm the navigation via alertComponent.
           * See more info about <Prompt /> component => https://reacttraining.com/react-router/core/api/Prompt
           */
          setNextLocation(location.pathname);
          setAlert(true);

          return false;
        }}
      />
      {variant === QUIZ_VARIANTS.GRADED_EXAM ? (
        <GradedExamModal
          isOpen={alert}
          primaryButtonLabel={'ออกจากแบบทดสอบ'}
          onPrimaryButtonClick={handleAllowNavigation}
          secondaryButtonLabel={'ทำแบบทดสอบต่อ'}
          onSecondaryButtonClick={handleBlockNavigation}
          {...gradedExamVariantProps}
        />
      ) : (
        <BlockNavigationDialogView
          open={alert}
          onCancel={handleBlockNavigation}
          onConfirm={handleAllowNavigation}
        />
      )}
    </Fragment>
  );
});

export default BlockNavigation;
